<template>
    <div class="box mt-3">
        <form @submit.prevent="submit">
            <h2 class="title is-4">
                {{ question.strQuestionLabel }}
            </h2>

            <FormNotification />

            <SavingNotification />

            <component
                :is="answerComponent"
                v-model="answer"
                v-validate="{ required: true }"
                name="answer"
                :question="question"
            />

            <b-button
                type="is-info"
                tag="button"
                :disabled="isSending || isSuccess || (! answer && ! answer.length)"
                native-type="submit"
            >
                Save
            </b-button>
        </form>
    </div>
</template>

<script>
import Form from '../mixins/form.js';
import AnswerBoolean from './AnswerBoolean.vue';
import AnswerInput from './AnswerInput.vue';
import AnswerMultiple from './AnswerMultiple.vue';
import AnswerSingle from './AnswerSingle.vue';
import AnswerSlider from './AnswerSlider.vue';

export default {

    components: {
        AnswerBoolean,
        AnswerInput,
        AnswerMultiple,
        AnswerSingle,
        AnswerSlider,
    },
    mixins: [
        Form,
    ],

    props: {
        question: {
            type: Object,
            required: true,
        },
    },

    data: function() {
        return {
            answer: '',
        };
    },

    computed: {
        answerComponent: function () {
            if(this.question.Answers) {
                return (this.question.blnIsMultipleAnswersAllowed ? 'answer-multiple' : 'answer-single');
            } else if(this.question.strFieldType == 'boolean') {
                return 'answer-boolean';
            } else if(this.question.strFieldType == 'currency') {
                return 'answer-slider';
            } else {
                return 'answer-input';
            }
        },
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
                .then((result) => {
                    if (! result) {
                        return this.parseClientErrors();
                    };

                    this.isSending = true;

                    this.$store.dispatch('leadQuestions/saveAnswer', {
                        leadQuestionPK: this.question.LeadQuestionPK,
                        answer: this.answer,
                    })
                    .then((response) => {
                        this.statusMessage = response.data.message;
                        this.statusType = 'success';
                        this.isSuccess = true;

                        this.$emit('answered');
                    })
                    .catch((error) => {
                        this.parseServerErrors(error);
                        this.isSuccess = false;
                    })
                    .then(() => {
                        this.isSending = false;
                    });
                });
        },
    },
};
</script>
